import { COLORS_CONFIG_BAR } from '@components/widgets/apacheEchart/Commons'
import { getCommonWidget } from '../../dashWidgetHelper'
import { commonWidgets, getHondaCustomerJourney, getHondaNpsBar, getNode, GREEN_1, HONDA_COLORS_CONFIG, HONDA_SCALE_3_COLORS, hondaScoringRadialMapper, isAllFilterByLevel, RED_1, userHas } from '../commonWidgetsHonda'
import { getLineDetailedRadar } from '../../widgetsLibrary/widgetsLine'
import { answeredMapper, invalidMapper, isGeoLocationLeaf } from '../../dashHelper'
import useAccount from '@hooks/useAccount'


export default {
    title: 'Honda - Postventa',
    description: 'Dashboard de Honda - Postventa',
    backgroundClassName: (filters) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI, filtersData: Record<string, any>) => {
        const { geoLocations } = useAccount();
        
        //Para filtra por nivel Distribuidor, todos los filtros deben ser del mismo nivel
        let isGroupLevelDistribuidor = isAllFilterByLevel(geoLocations, filters, 'DISTRIBUIDOR');
        const hasHonda = userHas(geoLocations, "HONDA");
        const hasAcura = userHas(geoLocations, "ACURA");

        
        const postventaScoringCategories = [
          { name: 'hon_postvta_composite_index_iniciacion', label: 'Iniciación' },
          { name: 'hon_postvta_composite_index_asesor', label: 'Asesor' },
          { name: 'hon_postvta_composite_index_instalaciones', label: 'Instalaciones' },
          { name: 'hon_postvta_composite_index_entrega', label: 'Entrega' },
          { name: 'hon_postvta_composite_index_calidad', label: 'Calidad' },
        ];

        const widgetsArray = [



 getLineDetailedRadar({
      mainIndicator: 'hon_postvta_npm_nos_recomendaria',
      radialIndicators: postventaScoringCategories.map(c => c.name),
      radialType: 'byIndicator',
      position: [0, 0],
      size: [4, 3],
      title: 'Satisfacción General',
      groupByLevel: 3,
      extras: {
        formula: 'nps-10',
      },
      extraConfigs: {
        backgroundColor: 'transparent',
        theme: 'dark',
        showRadialChart: true,
        initialVisibleChart: 1,
        showSample: false,
      },
      mapper: hondaScoringRadialMapper,
      // Los radialIndicators son el índice compuesto de scoring (formula propia,
      // fija por indicador); no deben heredar el 'nps-10' de extras.formula, que
      // es solo para el mainIndicator (NPS de "Satisfacción General").
      radialOmitFormula: true,
      useNormalizedRadial: true,
      normalizeBottom: 0,
      normalizeTop: 100,
      criticalMomentInclude: [1],
      indicatorsNames: postventaScoringCategories.reduce(
        (acc, c) => ({ ...acc, [c.name]: c.label }), {} as Record<string, string>
      ),
    }),
    //1
    {
      title: 'Encuestas',
      type: 'label',
      position: [0, 3],
      size: [4, 1],
      config: { color: '#B7AADC' },
    },
    
    
    
  
    
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS',
                //position: [0, 6],
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'hon_postvta_npm_nos_recomendaria',
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: HONDA_SCALE_3_COLORS,
                    useCurrent: 0,
                    categories: ['promoters', 'passives', 'detractors'],
                    categoriesLabel: ['Promotores', 'Neutros', 'Detractores'],
                    valueSymbol: '%',
                }
            }),

            getHondaNpsBar({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: 'NPS Detalle',
                key: 'bar-by-question-nps',
                size: [2, 2],
                indicator: 'hon_postvta_npm_nos_recomendaria',
                extraConfigs: {
                    colors: HONDA_SCALE_3_COLORS,
                    //groupLabels: mapLables,
                    showLegend: false,
                    valueFormat: ' >-.0',
                },
            }),
                
            
            getCommonWidget({
              commonWidgets: commonWidgets,
              name: 'surveyCountTrendByMonth',
              position: [0, 4],
              size: [1, 2],
              indicator: 'survey-response-counters',
              //criticalMomentId: 1,
              extras:{
                sort: { sortBy: 'group', value: 'asc' }
              }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Index',
                position: [1, 6],
                size: [1, 2]    ,
                // hon_postvta_composite_index expone "value" como el promedio de
                // puntos crudos (no porcentaje), ver CompositeWeightedScoreFormulaHandler
                // y SDD_indice_compuesto_postventa.md §2.5 ("850 de 1000, no porcentaje").
                indicator: 'hon_postvta_composite_index',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 1000,
                    showPercentage: false,
                }
            }),
getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGenericByStatus',
      title: 'widgets.calidadDatosVenta',
      position: [2, 6],
      size: [1, 2],
      mapper: invalidMapper,
      url: 'survey-responses/values',
      extraConfigs: {
        showPercentage: true,
      },
      //criticalMomentId: 1
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGenericByStatus',
      title: 'widgets.porcRespuestasVenta',
      position: [3, 6],
      size: [1, 2],
      mapper: answeredMapper,
      url: 'survey-responses/values',
      extraConfigs: {
        showPercentage: true,
      },
      //criticalMomentId: 1
    }),
    
    
            getHondaCustomerJourney({
                  id: 'cj-postventa',
                  //position: [0, 12],
                  size: [4, 2],
                  indicators: postventaScoringCategories,
                  title: 'Proceso de postventa',
                  mapper: (data: any) => {
                    return postventaScoringCategories.map(({ name, label }) => {
                      const rows = data[name]
                      const first = Array.isArray(rows) ? rows[0] : rows
                      const value = Number(first?.value)
                      const maximo = Number(first?.maximo)
                      const percent = maximo > 0 ? (value / maximo) * 100 : (value || 0)
                      return { label, value: percent }
                    })
                  },
                }),




            !isGroupLevelDistribuidor ?
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByGeoBest',
      title: 'widgets.bestGeoLocationsVentaGrupo',
      position: [2, 10],
      size: [2, 2],
      extraConfigs: {
        backgroundColor: '#501C78',
        titleBackgroundColor: '#88DD76',
        symbol: '',
        showFirstIndex: true,
        id: 'rankingByGeoBestGrupo',
      },
      indicator: 'hon_postvta_npm_nos_recomendaria',
      extras: {
        groupByLevel: 3,        
      },
            })
            :undefined,

            !isGroupLevelDistribuidor ?
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByGeoWorst',
      title: 'widgets.worstGeoLocationsVentaGrupo',
    
      position: [3, 10],
      size: [2, 2],
      extraConfigs: {
        backgroundColor: '#501C78',
        titleBackgroundColor: '#db7476',
        symbol: '',
        showFirstIndex: true,
        id: 'rankingByGeoWorstGrupo',
      },
      indicator: 'hon_postvta_npm_nos_recomendaria',
      extras: {
        groupByLevel: 3,        
      },
            })
            :undefined,

            !isGroupLevelDistribuidor ?
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByGeoBest',
      title: 'widgets.bestGeoLocationsVentaDist',
      position: [2, 10],
      size: [2, 4],
      extraConfigs: {
        backgroundColor: '#501C78',
        titleBackgroundColor: '#88DD76',
        symbol: '',
        showFirstIndex: true,

        limit: 11,
        maxSlice: 11,
      },
      indicator: 'hon_postvta_npm_nos_recomendaria',
      extraIndicatorConfigs: {
        //limit: 11,
      },
            })
            :undefined,

    
            !isGroupLevelDistribuidor ?
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByGeoWorst',
      title: 'widgets.worstGeoLocationsVentaDist',
      position: [3, 10],
      size: [2, 4],
      extraConfigs: {
        backgroundColor: '#501C78',
        titleBackgroundColor: '#db7476',
        symbol: '',
        showFirstIndex: true,
        limit: 11,
        maxSlice: 11,
      },
      indicator: 'hon_postvta_npm_nos_recomendaria',
      //    criticalMomentInclude: [1, 11703],
      extraIndicatorConfigs: {
        //limit: 11,
      }
            })
            :undefined,




    

  {
    title: 'Nube de Palabras / Frecuencia en comentarios',
    position: [0, 13],
    size: [2, 2],
    config: {
      id: 'word-count',
      type: 'wordCloud',
      mapper: (data: any, extra: any) => {
        return data !== undefined
          && data.map !== undefined
          ? data.map((item: any) => ({
              ...item,
              group: item.group ?? item.category
            }))
          : []
      },
      indicators: [
        {
          indicator: 'WORD_COUNT',
          keyExtract: ['count', 'value', 'group','category'],
          singleton: true,
        },
      ],
    },
  },




    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByTagBest',
      title: 'widgets.bestTagsVenta',
      position: [2, 13],
      size: [2, 2],
      indicator: 'sentiment',
      //criticalMomentId: 1,
      extras: {
        trunc: 'HALF_DOWN',
        topSize: 3,
      },
      extraConfigs: {
        layout: 'signal',
        tone: 'positive',
        headerBadge: 'Top',
        countLabel: 'menciones',
        color: GREEN_1,
      },
      extraIndicatorConfigs: {
        limit: 2,
        value: 'count',
      },    
    }),    
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByTagWorst',
      title: 'widgets.worstTagsVenta',
      position: [2, 15],
      size: [2, 2],
      indicator: 'sentiment',
      //criticalMomentId: 1,
      extras: {
        resultType: 'bottom',
        trunc: 'HALF_UP',
        bottomSize: 3,
      },
      extraConfigs: {
        layout: 'signal',
        tone: 'negative',
        headerBadge: 'Atención',
        countLabel: 'menciones',
        color: RED_1,
      },
      extraIndicatorConfigs: {
        limit: 2,
        value: 'count',
      },      
    }),
   
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'textAnalysis',
      title: 'widgets.sentimentAnalysis',
      position: [0, 15],
      size: [4, 3],
      //criticalMomentId: 1,
      extraConfigs:   {
          colors: HONDA_SCALE_3_COLORS, 
          typeColumn: 'percent', 
          //widgetTitle: 'Análisis de sentimientos top 6' ,
          groupKeys: ['positive', 'neutral', 'negative'],
          groupLabels: {'positive': 'Promotores', 'neutral': 'Neutros', 'negative': 'Detractores'},

      },
    }),

    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'diagramaIshikawa',
      title: 'Diagrama Ishikawa',
      position: [0, 18],
      size: [4, 3],
      indicator: 'sentiment',
      //criticalMomentId: 1,
    }),
    

     {
      title: 'ASESOR',
      type: 'label',
      size: [4, 1],
    },
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: 'Una vez que arribó a las instalaciones del distribuidor. ¿Cuánto tiempo esperó para hablar con un asesor para confirmar sus necesidades del servicio?',
                size: [2, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'hon_postvta_espera_confirmar_serv'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: 'La persona que lo recibió. ¿Conocía el historial de servicio de su vehículo?',
                size: [2, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'hon_postvta_asesor_conocia_historial'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: '¿Inspeccionaron su vehículo y le ofrecieron asesoría útil basada en sus solicitudes y/o necesidades?',
                size: [2, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'hon_postvta_asesor_inspecciono_vehiculo'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: '¿Le informaron cuándo estaría listo su vehículo antes de iniciar el trabajo?',
                size: [1, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'hon_postvta_asesor_informo_fecha_fin_antes'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: '¿Lo mantuvieron informado del estatus de su vehículo?',
                size: [1, 2]    ,
                indicator: 'hon_postvta_informado_estado_vehiculo',
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: '¿Qué método prefiere para ser informado del estatus de su vehículo?',
                size: [2, 2]    ,
                indicator: 'hon_postvta_medio_informe_estado_vehiculo',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
           
            
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: '¿Cómo evalúa la cortesía del asesor de servicio?',
                size: [1, 2]    ,
                indicator: 'hon_postvta_npm_cortesia_servicio',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: '¿Cómo evalúa la capacidad de respuesta del asesor de servicio?',
                size: [1, 2]    ,
                indicator: 'hon_postvta_npm_capacidad_rta',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: '¿Qué tan minuciosa fue la explicación del trabajo realizado?',
                size: [1, 2]    ,
                indicator: 'hon_postvta_npm_explicacion_trabajo',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: '¿Cómo evalúa los conocimientos del asesor de servicio?',
                size: [1, 2]    ,
                indicator: 'hon_postvta_npm_conocimientos_asesor',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: 'Referente a la calidad del servicio. ¿Su vehículo fue reparado apropiadamente como usted lo esperaba en esta visita?',
                size: [2, 2],
                indicator: 'hon_postvta_reparacion_adecuada',
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
            }),

    {
      title: 'INSTALACIONES',
      type: 'label',
      size: [4, 1],
    },
              getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: 'Durante el tiempo de servicio para usted, ¿qué situación lo describe mejor?',
                size: [2, 2]    ,
                indicator: 'hon_postvta_tiempo_servicio_describe',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: '¿Cómo evalúa la limpieza de las instalaciones en general?',
                size: [1, 2]    ,
                indicator: 'hon_postvta_npm_limpieza_general',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: '¿Cómo evalúa la calidad y variedad de las amenidades ofrecidas?',
                size: [1, 2]    ,
                indicator: 'hon_postvta_npm_calidad_amenidades',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
           

    {
      title: 'INICIACIÓN',
      type: 'label',
      size: [4, 1],
    },

              getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: '¿Logró agendar su cita en la fecha y hora deseada?',
                size: [1, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'hon_postvta_agendo_cita'
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Facilidad para agendar cita',
                position: [1, 6],
                size: [1, 2]    ,
                indicator: 'hon_postvta_npm_facilidad_cita',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: '¿Cómo evalúa la facilidad para ingresar al área de servicio y encontrar un lugar dónde estacionarse?',
                size: [1, 2]    ,
                indicator: 'hon_postvta_npm_facilidad_ingresar_area',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: '¿Cómo evalúa la prontitud del ingreso de su vehículo?',
                size: [1, 2]    ,
                indicator: 'hon_postvta_npm_prontitud_ingreso',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: '¿Cuál opción describe mejor su visita a servicio?',
                size: [2, 2]    ,
                indicator: 'hon_postvta_desc_visita',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

    {
      title: 'ENTREGA',
      type: 'label',
      size: [4, 1],
    },
              getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: '¿Le fue provisto y explicado a detalle del costo antes de iniciar el trabajo?',
                size: [2, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'hon_postvta_asesor_explico_costo_antes'
            }),
            
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: '¿Su automóvil fue entregado en la fecha y hora prometida?',
                size: [1, 2]    ,
                indicator: 'hon_postvta_entrega_fecha_comprometida',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: '¿Recibió una explicación del trabajo realizado y le mostraron las partes reemplazadas?',
                size: [1, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'hon_postvta_entrega_explicacion_trabajo'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: '¿Recibió de su asesor la explicación de la hoja multipuntos?',
                size: [1, 2]    ,
                indicator: 'hon_postvta_asesor_exlicacion_multipuntos',
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: '¿Cómo evalúa el tiempo que se llevó el proceso administrativo para la entrega de su vehículo?',
                size: [1, 2]    ,
                indicator: 'hon_postvta_npm_tiempo_administrativo',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: '¿Cómo evalúa la ayuda del staff de servicio durante la entrega de su vehículo?',
                size: [1, 2],
                indicator: 'hon_postvta_npm_ayuda_staff',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: '¿Cómo considera el valor por lo que pago?',
                size: [1, 2],
                indicator: 'hon_postvta_npm_pago_adecuado',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

    {
      title: 'CALIDAD',
      type: 'label',
      size: [4, 1],
    },
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: 'Después de 2 a 3 días posteriores a su visita. ¿El distribuidor le contactó para saber si todo fue de su agrado?',
                size: [1, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'hon_postvta_contacto_posterior'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: '¿Cómo evalúa el tiempo total requerido para completar el servicio / reparación de su vehículo?',
                size: [1, 2]    ,
                indicator: 'hon_postvta_npm_tiempo_servicio',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: '¿Cómo evalúa la condición de su vehículo al serle devuelto?',
                size: [1, 2],
                indicator: 'hon_postvta_npm_condicion_vehiculo_devuelto',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: '¿Cómo evalúa la minuciosidad del trabajo realizado en su vehículo?',
                size: [1, 2],
                indicator: 'hon_postvta_npm_minuciosidad_trabajo',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'lastComments',
                title: 'Indique cualquier detalle adicional en algún problema en específico que no fue reparado o atendido correctamente.',
                size: [4, 2],
                indicator: 'hon_postvta_coment_problema_no_resuelto',
                helpText: "Por favor, indique cualquier detalle adicional en algún problema en específico que no fue reparado o atendido correctamente.",
                extraConfigs: {
                    maxCommentSize: 120
                }
            }),


    {
      title: 'OTROS INDICADORES',
      type: 'label',
      size: [4, 1],
    },
            getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'gaugeGeneric',
        title: '¿Qué tanto le gustaría regresar a este distribuidor para trabajos de servicio?',
        size: [1, 2],
        indicator: 'hon_postvta_npm_regresaria',
        extraConfigs: {
            decimals: 1,
            maxValue: 100,
            showPercentage: true,
        }
    }),









 

            



            
             
            

            
            
            

     {
      title: 'widgets.otherIndicators',
      type: 'label',
      position: [0, 21],
      size: [4, 1],
    },            
            
            
            
            
            
            






getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'barByGeo',
      title: 'widgets.zonalSatisfactionPostventa',
      key: 'venta-satisfaction-zona',
      position: [1, 28],
      size: [4, 2],
      indicator: 'hon_postvta_npm_nos_recomendaria',
      //criticalMomentId: 1,
      extraConfigs: {
        colors: HONDA_COLORS_CONFIG,
        itemsWidth: 200,
        decimals: 1,
        maxValue: 100,
        showLegend:false,
      },
      render: (filters) => {
        return !isGeoLocationLeaf(filters, filtersData)
      },
      extras: {
        groupByLevel: 2
      },
    }),

    hasHonda?
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'barByGeo',
      title: 'widgets.grupoSatisfactionHonda',
      key: 'venta-satisfaccion-grupo-honda',
      position: [0, 30],
      size: [4, 2],
      indicator: 'hon_postvta_npm_nos_recomendaria',
      //criticalMomentId: 1,
      extraConfigs: {
        colors: HONDA_COLORS_CONFIG,
        itemsWidth: 200,
        percentageScale: true,
        decimals: 1,
        maxValue: 100,
        showLegend:false,
        rotateXAxisLegend: true,
        wrapTexts: true,
        labelFontSize: 10,
      },
      extras: {
        geoLocationInclude: [1],
        groupByLevel: 3
      },
      render: (filters) => {
        return !isGeoLocationLeaf(filters, filtersData)
      },
      mapper: (data: any) => {
        //console.info('data mapper')
        //console.info(data)
        return [...data].sort((a: any, b: any) => b.value - a.value).map((item: any) => ({
          ...item,
          label: item.label !== undefined
            ? item.label.replaceAll('MITSUBISHI ', '')
            : item.label
        }))
      },
    })
    : undefined,

    hasHonda?
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'barByGeo',
      title: 'widgets.distribuidorSatisfactionHonda',
      key: 'venta-satisfaccion-dist-honda-distribuidor',
      position: [0, 30],
      size: [4, 2],
      indicator: 'hon_postvta_npm_nos_recomendaria',
      //criticalMomentId: 1,
      extraConfigs: {
        colors: HONDA_COLORS_CONFIG,
        itemsWidth: 200,
        percentageScale: true,
        decimals: 1,
        maxValue: 100,
        rotateXAxisLegend: true,
        wrapTexts: true,
        labelFontSize: 10,
        showLegend:false,        
      },
      extras: {
        geoLocationInclude: [1],
        groupByLevel: 6
      },
      render: (filters) => {
        return !isGeoLocationLeaf(filters, filtersData)
      },
      mapper: (data: any) => {
        return [...data].sort((a: any, b: any) => b.value - a.value).map((item: any) => ({
          ...item,
          label: item.label !== undefined
            ? item.label.replaceAll('MITSUBISHI ', '')
            : item.label
        }))
      },
    })
    : undefined,

    hasAcura?
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'barByGeo',
      title: 'widgets.grupoSatisfactionAcura',
      key: 'venta-satisfaccion-dist-acura',
      position: [0, 30],
      size: [4, 2],
      indicator: 'hon_postvta_npm_nos_recomendaria',
      //criticalMomentId: 1,
      extraConfigs: {
        colors: HONDA_COLORS_CONFIG,
        itemsWidth: 200,
        percentageScale: true,
        decimals: 1,
        maxValue: 100,
        rotateXAxisLegend: true,
        wrapTexts: true,
        labelFontSize: 10,
        showLegend:false,
      },
      //geoLocationId: 2,
      extras: {
        geoLocationInclude: [2],
        groupByLevel: 3
      },
      render: (filters) => {
        return !isGeoLocationLeaf(filters, filtersData)
      },
      mapper: (data: any) => {
        return [...data].sort((a: any, b: any) => b.value - a.value).map((item: any) => ({
          ...item,
          label: item.label !== undefined
            ? item.label.replaceAll('MITSUBISHI ', '')
            : item.label
        }))
      },
    })
    : undefined,

    hasAcura?
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'barByGeo',
      title: 'widgets.distribuidorSatisfactionAcura',
      key: 'venta-satisfaccion-dist-acura',
      position: [0, 30],
      size: [4, 2],
      indicator: 'hon_postvta_npm_nos_recomendaria',
      //criticalMomentId: 1,
      extraConfigs: {
        colors: HONDA_COLORS_CONFIG,
        itemsWidth: 200,
        percentageScale: true,
        decimals: 1,
        maxValue: 100,
        rotateXAxisLegend: true,
        wrapTexts: true,
        labelFontSize: 10,
        showLegend:false,
      },
      //geoLocationId: 2,
      extras: {
        geoLocationInclude: [2],
        groupByLevel: 6
      },
      render: (filters) => {
        return !isGeoLocationLeaf(filters, filtersData)
      },
      mapper: (data: any) => {
        return [...data].sort((a: any, b: any) => b.value - a.value).map((item: any) => ({
          ...item,
          label: item.label !== undefined
            ? item.label.replaceAll('MITSUBISHI ', '')
            : item.label
        }))
      },
    })
    : undefined,
            
    ].filter(w => w != undefined);
    return widgetsArray;
  },
} as DasboardConfig
